
export class RoundHelper {

    /**
     * Rounds number to given number of decimals
     * Previous implementation using decimal:
     * const decimal = new Decimal(x);
     * const rounded = decimal.toDecimalPlaces(decimals).toNumber();
     */
    roundTo(x: number, decimals: number, applyRound: boolean = true): number {
        if (!applyRound) {
            return x;
        }
        if (!x) {
            return 0;
        }

        return +x.toFixed(decimals);
    }
}

export const roundHelper = new RoundHelper();
